module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_03_american-village-1f0f17529563ee3ec433bc2920d2048b.jpg";